import api from "../common/api";

const create = (data) => api.post("push-notifications", data);

const pushNotificationService = {
  create,
};

export default pushNotificationService;
